'use es6';

import { getCanViewInbox, getIsUserInPortal, getIsRoutable } from './userGetters';
import { Iterable } from 'immutable';
export const isErroredRoutingUser = user => {
  if (Iterable.isIterable(user)) {
    return !getCanViewInbox(user) || !getIsUserInPortal(user) || !getIsRoutable(user);
  }
  return !user.canViewInbox || !user.userInPortal || !user.routable;
};